import axios from 'axios'

export const getTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

axios.interceptors.request.use((config) => {
  config.headers = config.headers ?? {}
  config.headers.Timezone = getTimezone()
  return config
})
